import React, { Component } from "react";
import "./../../styles/invoice.css";

import * as service from "./../../Service/service";

class OrderSummaryComponent extends Component {
  state = {
    orderNumber: "",
    orderInfo: {},
    slugs: [],
    address: {},
    showData: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      orderNumber: props.match.params.orderNumber,
    };
  }

  componentWillMount() {
    this.orderInfoByOrderNumber();
  }

  onLoginRoute = () => {
    window.location.href =
      "/login?url=" +
      encodeURIComponent(
        `${window.location.pathname}${window.location.search}${window.location.hash}`
      );
  };

  checkAddress = () => {
    service.checkAddress(this.state.orderInfo.addressId).then(
      (response) => {
        this.setState(
          {
            ...this.state,
            address: response.data,
            showData: true,
          },
          () => {
            console.log(this.state);
          }
        );
      },
      (error) => {
        console.log(error);
      }
    );
  };

  mergeProductInfo = () => {
    let tmpState = JSON.parse(JSON.stringify(this.state));

    service.cartProductInfo(this.state.slugs).then(
      (response) => {
        response.data.map((prod) => {
          tmpState.orderInfo.productList.map((item) => {
            if (item.productSlug === prod.slug) {
              item.productInfo = prod;
            }
          });
        });

        this.setState(tmpState, () => {
          this.checkAddress();
        });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  orderInfoByOrderNumber = () => {
    service.orderInfoByOrderNumber(this.state.orderNumber).then(
      (response) => {
        if (!response.data && localStorage.keycloak) {
          alert("Unauthorized access");
        } else if (response.data) {
          var slugs = [];
          response.data.productList.map((elem) => {
            slugs.push(elem.productSlug);
          });

          this.setState(
            {
              ...this.state,
              orderInfo: response.data,
              slugs: slugs,
            },
            () => {
              this.mergeProductInfo();
            }
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };
  statusColor = (orderStatus) => {
    if (orderStatus == "DELIVERED") {
      return "text-success ml-3";
    } else if (
      orderStatus == "PAYMENT_AWAITED" ||
      orderStatus == "ENQUIRY_AWAITED"
    ) {
      return "text-warning ml-3";
    } else {
      return "text-danger ml-3";
    }
  };

  render() {
    return (
      <React.Fragment>
        {localStorage.keycloak && this.state.showData && (
          <div className="body p-3 mt-5">
            <div className="row">
              <div className="col-12 text-center">
                <img
                  width="180px"
                  src="data:image/png;base64,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"
                />
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-7">
                <span style={{ position: "relative", left: "-15px" }}>
                  <span className="font-weight-bold">
                    {this.state.address.name}
                  </span>{" "}
                  <br />
                  {this.state.address.houseNo} {this.state.address.address1}
                  <br />
                  {this.state.address.address2} <br />
                  {this.state.address.city} {this.state.address.pincode}
                  <br />
                  Contact : {this.state.address.contactNo}
                  <br />
                </span>

                <div className="row mt-3">
                  <div
                    className="col-12 font-weight-bold"
                    style={{ background: "#DDD", padding: "10px" }}
                  >
                    <span>Order Number :</span>
                    <span> {this.state.orderInfo.orderNumber}</span>
                    <span
                      className={this.statusColor(
                        this.state.orderInfo.orderStatus
                      )}
                    >
                      {this.state.orderInfo.orderStatus}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-4 offset-1 mt-auto p-0">
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Placed On</td>
                      <td>
                        {new Date(
                          this.state.orderInfo.orderDate
                        ).toLocaleDateString()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div
                className="col-12 font-weight-bold text-center mt-3"
                style={{
                  background:
                    "linear-gradient(270deg, rgb(232, 85, 78), rgb(1, 73, 127))",
                  color: "white",
                  padding: "10px",
                }}
              >
                <span>Your Order Details</span>
              </div>

              <div className="col-12 p-0 mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Items</th>
                      <th>Duration</th>
                      <th>Quanity</th>
                      <th>Rent (Excl.GST)</th>
                      <th>SGST</th>
                      <th>CGST</th>
                      <th>Rent (Incl.GST)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.orderInfo.productList.map((item, key) => (
                      <tr>
                        <td>{item.productInfo.name}</td>
                        <td>{item.productInfo.category.slug != 'seasonal'? `${item.tenure} Months` : 'N/A'}</td>
                        <td>{item.quantity}</td>
                        <td>
                          Rs.{" "}
                          {this.state.orderInfo.isMedical
                            ? this.state.orderInfo.securityDeposit[key].rent *
                              item.quantity
                            : (
                                (parseFloat(
                                  this.state.orderInfo.securityDeposit[key].rent
                                ) ) /
                                1.18
                              ).toFixed(2)}
                        </td>
                        <td>
                          Rs.{" "}
                          {(
                            ((parseFloat(
                              this.state.orderInfo.securityDeposit[key].rent
                            )) /
                              1.18 /
                              100) *
                            9
                          ).toFixed(2)}
                        </td>
                        <td>
                          Rs.{" "}
                          {(
                            ((parseFloat(
                              this.state.orderInfo.securityDeposit[key].rent
                            )) /
                              1.18 /
                              100) *
                            9
                          ).toFixed(2)}
                        </td>
                        <td>
                          Rs.{" "}
                          {this.state.orderInfo.isMedical
                            ? (
                                parseFloat(
                                  this.state.orderInfo.securityDeposit[key]
                                    .rent * parseFloat(item.quantity)
                                ) +
                                this.state.orderInfo.securityDeposit[key].rent *
                                  0.18
                              ).toFixed(2)
                            : parseFloat(
                                this.state.orderInfo.securityDeposit[key].rent
                              ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div
                className="col-12 font-weight-bold text-center"
                style={{
                  background:
                    "linear-gradient(270deg, rgb(232, 85, 78), rgb(1, 73, 127))",
                  color: "white",
                  padding: "10px",
                }}
              >
                <span>Billing Details</span>
              </div>

              <div className="col-5 p-0 mt-3">
                <span className="font-weight-bold">Deposit & Monthly Bill</span>
                <table className="table table-bordered mt-2">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">{this.state.orderInfo.productList[0].productInfo.category.slug == 'premium'?'Advance':'Total Deposit'}</td>
                      <td>
                        Rs.{" "}
                        {this.state.orderInfo.orderTerms.totalDeposit.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Monthly Bill</td>
                      <td>
                        Rs.{" "}
                        {this.state.orderInfo.orderTerms.monthlyBillAmount.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-6 offset-1 p-0 mt-3">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Total Amount</td>
                      <td>
                        Rs.{" "}
                        {(this.state.orderInfo.orderTerms.monthlyBillAmount + this.state.orderInfo.orderTerms.discount).toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">
                        Discount
                        <span className="text-black-50">
                          {" "}
                          ( {this.state.orderInfo.couponId} )
                        </span>
                      </td>
                      <td>
                        {" "}
                        Rs. -
                        {this.state.orderInfo.orderTerms.discount.toFixed(
                          2
                        )}{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Final Amount</td>
                      <td>
                        Rs.{" "}
                        {this.state.orderInfo.orderTerms.monthlyBillAmount.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">{this.state.orderInfo.productList[0].productInfo.category.slug == 'premium'?'Advance Amount':'Deposit Amount'} </td>
                      <td>
                        Rs.{" "}
                        {this.state.orderInfo.orderTerms.totalDeposit.toFixed(
                          2
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Total Paid</td>
                      <td>
                        Rs.{" "}
                        {(this.state.orderInfo.orderTerms.monthlyBillAmount + this.state.orderInfo.orderTerms.totalDeposit).toFixed(2) }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mb-5 mt-3">
              <div
                className="col-12 text-black-50"
                style={{ background: "rgb(245, 243, 243)", padding: "12px" }}
              >
                <span>
                  NOTE: Security deposit will get returned after order tenure is
                  over & items are picked up back by Voorent team.
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-12 text-center">
                {/* <span className="text-black-50">
                  Kindly pay the amount before due date to avoid late fee
                  charges. Due is 15 days from date of generation of invoice.
                </span> */}
                <table className="m-auto">
                  <tr>
                    <td>
                      <a
                        target="_blank"
                        className="font-weight-bold"
                        style={{ color: "#00487f" }}
                        href="https://voorent.com/privacy-policy"
                      >
                        Privacy Policy
                      </a>
                    </td>
                    <td>
                      <a
                        target="_blank"
                        className="font-weight-bold"
                        style={{ color: "#00487f" }}
                        href="https://voorent.com/terms-conditions"
                      >
                        Terms And Conditions
                      </a>
                    </td>
                    <td>
                      <a
                        target="_blank"
                        className="font-weight-bold"
                        style={{ color: "#00487f" }}
                        href="https://voorent.com/faq"
                      >
                        FAQ
                      </a>
                    </td>
                  </tr>
                </table>

                <table className="m-auto">
                  <tr>
                    <td>
                      <a href="https://www.facebook.com/Voorent.rentals">
                        <img
                          width="32px"
                          src="https://voorent.com/voorent-storage/images/facebook.png"
                        />
                      </a>
                    </td>
                    <td>
                      <a href="https://www.linkedin.com/company/voorent?originalSubdomain=in">
                        <img
                          width="32px"
                          src="https://voorent.com/voorent-storage/images/linkedin.png"
                        />
                      </a>
                    </td>
                  </tr>
                </table>

                <span className="display-block">
                  Copyright © 2017 - 2020 Voorent Pvt. Ltd.™ All Rights Reserved
                </span>
                <span className="display-block">
                  Basement, 258, Sector 27, Gurugram, Haryana 122022
                </span>
              </div>
            </div>
          </div>
        )}
        {localStorage.keycloak == null && this.onLoginRoute()}
      </React.Fragment>
    );
  }
}

export default OrderSummaryComponent;
